/* eslint-disable import/no-anonymous-default-export */
/* eslint-disable no-empty-pattern */
import React from "react";
import { useIdleTimer } from "react-idle-timer";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../model/application/state";
import { UtilityConfig } from "../../service/action/utility";

export default function (Props: any) {
  const dispatch = useDispatch();
  const { utilityState }: any =
    useSelector((state) => state);
  const config: State.Config = utilityState;

  const logout = () => {
    dispatch({
      type: UtilityConfig.Logout,
      payload: {
        ...config,
        logoutConfirmation: true,
        title: "Your session has expired",
        message: "Login to continue"
      },
    });
  };

  const {} = useIdleTimer({
    timeout: 600000,
    onIdle: () => {logout()},
    debounce: 500,
  });
  return <></>;
}
